/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
export function isEven(params) {
  return params[0] % 2 === 0;
}

export default buildHelper(isEven);
